import { render, staticRenderFns } from "./App.vue?vue&type=template&id=04b0f764"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=04b0f764&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../空降-sp-弯弯介绍的/kj-德语-源码/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports